import { AdvancedPlansFeature, StringMap } from 'types';

export function filterFeaturesBySpec(
  features: AdvancedPlansFeature[],
  experiments: StringMap,
): AdvancedPlansFeature[] {
  return features.filter((feature) => {
    if (feature.includedBySpec && feature.excludedBySpec) {
      throw new Error(
        `Feature ${feature.translationKey} was defined to be both excluded and included in specific experiment`,
      );
    }
    if (feature.includedBySpec) {
      if (typeof feature.includedBySpec === 'string') {
        return experiments[feature.includedBySpec] === 'true';
      }
      return feature.includedBySpec.some(
        (spec) => experiments[spec] === 'true',
      );
    }

    if (feature.excludedBySpec) {
      if (typeof feature.excludedBySpec === 'string') {
        return experiments[feature.excludedBySpec] !== 'true';
      }
      return !feature.excludedBySpec.some(
        (spec) => experiments[spec] === 'true',
      );
    }
    return true;
  });
}
